export default __webpack_public_path__ + "static/logo-prezi-d0eca48b8675a452efd2214e33cb755f.png";